import React from 'react'
import { useTranslation } from 'react-i18next'
import GenericStatsDetails from './GenericStatsDetails'

const VehicleInvoices: React.FC = () => {
  const { t } = useTranslation()

  return <GenericStatsDetails entity='vehicleInvoice' entityTranslation={t('global.stats.vehicle_invoices')} icon='file alternate' />
}

export default VehicleInvoices
